import React from 'react';
import LearnerNumberTag from './LearnerNumberTag';

// 演習画面の一番上の見出し（「形状変更演習」等）。同じ行の右端に学習者番号を出し、
// 演習の途中でも自分の番号を確かめられるようにする（2026-10-14）。
function ExerciseHeading({ title }) {
  return (
    <div className="exercise-heading">
      <h1 className="heading-hero">{title}</h1>
      <LearnerNumberTag />
    </div>
  );
}

export default ExerciseHeading;
